import React from 'react';
import UserManagement from '../components/UserManagement';

function UserManagementPage() {
  return (
    <div style={{ background: '#F5F5F5', minHeight: '100vh', padding: '40px 0' }}>
      <UserManagement />
    </div>
  );
}

export default UserManagementPage; 